module.exports = __webpack_public_path__ + "img/navigate-to-hotel.c3bbbbed.svg";